import { CampaignFragment, Maybe } from '@business/gql/graphql';
import { Dictionary } from '@ts/dictionary';
import { ContentfulImage } from '@ui/components/Contentful';
import { Heading } from '@ui/components/Heading/Heading';
import Link from '@ui/components/Link/Link';
import Paragraph from '@ui/components/Paragraph/Paragraph';
import config from '@utils/config';

type Props = {
  campaign?: Maybe<CampaignFragment>;
  dictionary: Dictionary;
};

export const CampaignCarouselItem = ({ campaign, dictionary }: Props) => {
  const { locale } = config;

  if (!campaign) return null;

  return (
    <div key={campaign?.slug} className="flex flex-col gap-y-3">
      <Link key={campaign?.slug} locale={locale} href={campaign?.slug ?? ''}>
        {campaign?.campaignImage && (
          <ContentfulImage
            className="mb-1 aspect-portrait w-full object-cover"
            desktopImage={campaign.campaignImage}
            sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, (max-width: 1024px) 33vw, (max-width: 1920px) 25vw, 30em"
          />
        )}
      </Link>
      <Heading size={4}>{campaign?.campaignTitle}</Heading>
      {campaign?.shortDescription && (
        <Paragraph className="mb-1 text-sm">
          {campaign?.shortDescription}
        </Paragraph>
      )}

      <Link href={campaign?.slug ?? ''} className="group">
        <Paragraph className="text-sm text-black underline">
          {dictionary.toCampaign}
        </Paragraph>
      </Link>
    </div>
  );
};
